import Restaurant from "../models/Restaurant";
import { getRestaurantOrderCallbackPath } from "./restaurant";

export const generateSwishAppLink = (orderId: string, restaurant: Restaurant, swishToken: string) => {
    const callbackUrl = getRestaurantOrderCallbackPath(orderId, restaurant);
    const appUrl = `swish://paymentrequest?token=${swishToken}&callbackurl=${callbackUrl}`;
    return appUrl;
}